<div class="progress"
     [ngbTooltip]="'System load: ' + activeDeviceSyncsPercentage() + ' %'">
  <div class="progress-bar progress-bar-striped progress-bar-animated"
       [class.bg-success]="activeDeviceSyncsPercentage() <= 40"
       [class.bg-warning]="activeDeviceSyncsPercentage() > 40 && activeDeviceSyncsPercentage() < 80"
       [class.bg-danger]="activeDeviceSyncsPercentage() >= 80"
       role="progressbar"
       [attr.aria-valuenow]="currentActiveDeviceSyncs()"
       [attr.aria-valuemax]="maximumActiveDeviceSyncs()"
       aria-valuemin="0"
       [style.width.%]="activeDeviceSyncsPercentage()"></div>
</div>